import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Modal, Button, Tab, Tabs, Form, Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faCircleXmark, faTrashCan, faPencil, faEnvelope, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { Prev } from 'react-bootstrap/esm/PageItem';
import Arcv from "../../../assets/images/archive.svg";
import Active from "../../../assets/images/active.svg";
import ImageUpload from '../../../Components/common/ImageUpload.js';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { ULDADDRESSSAVE, ULDSTATIONDETAILS, ULDADDRESSACTARC, ULDADDRESSRECMAIL, DELETERECEMAIL } from '../../../Utils/conts.js';
import { toast } from 'react-toastify';
import { CallApi, jqxCookieCall } from '../../../Components/common/CommonFunctions.js';
import ConfModal from '../../../Components/common/ConfModal.js';
import TabbedGrids from '../../../Components/common/TabbedGrid.js';

const AirlineSettings = () => {

       const gridRefs = {
          Active: useRef(null),
          Archived: useRef(null)
        };

  // console.log('999', rowData);
  const isMounted = useRef(false);
  const [formData, setFormData] = useState({});
  const [show, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState('');
  const [reloadKey, setReloadKey] = useState(0);
  const [gridEvents,setGridEvents] = useState("")
  // const token = localStorage.ULD;
  jqxCookieCall();


  const makeSource = tab => ({
    datatype: 'json',
    datafields: [
          { name: 'id', type: 'string' },
          { name: 'airline_name', type: 'string' },
          { name: 'airline_prefix', type: 'string' },
          { name: 'owner_code', type: 'string' },
          { name: 'emails', type: 'string' },
          { name: 'total_emails_count', type: 'string' },
    ],
    url: `${process.env.REACT_APP_RFS_URL}handler-airline-settings/list?tab=${tab === 'Active' ? 'A' : 'R'}`,
    // beforeSend: xhr => xhr.setRequestHeader('Authorization', `Bearer ${token}`),
    root: 'Rows',
    cache: false,
  });


  const columns = useMemo(() => [
    { text: 'Airline Name', filtertype: 'textbox', datafield: 'airline_name', width: '20%', cellclassname: '', },
    { text: 'Airline Prefix', filtertype: 'textbox', datafield: 'airline_prefix', width: '25%', cellclassname: 'frcl', },
    { text: 'Owner Code', filtertype: 'textbox', datafield: 'owner_code', width: '27%', cellclassname: 'frcl', },
    { text: 'Total Emails', filtertype: 'textbox', datafield: 'total_emails_count', width: '23%', cellclassname: '', },
  ], []);


  const modalShow = (pos) => {
    setShow(true);
    setIsEdit(pos);
    if (pos == 'add') {
      setInputAddress({ id: '', company_name: '', agent_or_handler: '', agent_type: 'E', address: '', email: [''], phone_number: '' })
    } else {
      const setData = { ...selectedRowData, agent_type: selectedRowData.agent_type ? selectedRowData.agent_type : selectedRowData.regd || '', address_id: selectedRowData.address_id }
      setInputAddress(setData);
    }
  }
  const modalClose = () => setShow(false);

  const [inputAddress, setInputAddress] = useState({
    id: '', company_name: '', agent_or_handler: '', agent_type: 'E', address: '', email: [''], phone_number: ''
  });
  const [address, setAddress] = useState();

  // console.log("🚀 ~ StationDetails ~ address:", address)
  // const dispatch = useDispatch();
  // Validation 
  const validateFormData = () => {
    let isValid = true;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Function to validate email
    const validateEmail = (email) => {
      return emailRegex.test(email);
    };
    if (!inputAddress.company_name) {
      console.log('Text input is required');
      toast.error('Company Name must not be blank');
      isValid = false;
    } else if (!inputAddress.agent_or_handler) {
      console.log('Text input is required');
      toast.error('Please select Agent or Handler');
      isValid = false;
    }
    // else if (!inputAddress.address) {
    //     console.log('Text input is required');
    //     toast.error('Address must not be blank');
    //     isValid = false;
    // } else if (!inputAddress.phone_number) {
    //     console.log('Text input is required');
    //     toast.error('Phone Number must not be blank');
    //     isValid = false;
    // } else if (!/^\d{10}$/.test(inputAddress.phone_number)) {
    //     console.log('10');
    //     toast.error('Phone Number must be 10 Digits');
    //     isValid = false;
    // } else if (!inputAddress.email) {
    //     console.log('Text input is required');
    //     toast.error('Email must not be blank');
    //     isValid = false;
    // } else if (!validateEmail(inputAddress.email)) {
    //     console.log('Invalid email address');
    //     toast.error('Invalid email address');
    //     isValid = false;
    // }
    else {
      return isValid;
    }
  };

  const addAddress = async (e) => {
    // console.log('444', inputAddress);
    if (validateFormData()) {
      e.preventDefault();
      const NewInputAddress = { ...inputAddress, station_id: 'stationid' };

      const dataToSend = {
        ...inputAddress,
        station_id: 'stationid',

        // company_name: inputAddress.company_name,
        // agent_or_handler: inputAddress.agent_or_handler,
        // address: inputAddress.address,
        // email: inputAddress.email,
        // phone_number: inputAddress.phone_number
      };
      // console.log("🚀 ~ addAddress ~ dataToSend:", dataToSend)

      if (inputAddress.agent_or_handler === 'A') {
        dataToSend.agent_type = inputAddress.agent_type;
      }

      // const updatedAddress = [...address, NewInputAddress];
      // if (updatedAddress) {
      //     dispatch(addAddressData(NewInputAddress)); // Pass sendStationData to addData thunk
      //   }
      if (NewInputAddress) {
        try {
          const res = await withRFSToken.post(ULDADDRESSSAVE, dataToSend)
            .then(function (res) {
              // const innerData = res;
              // console.log("🚀 ~ .then ~ innerData:", innerData)
              if (res.data.response_code == 200) {
                // fetchDataGrid();
                // setAddress(res.data.response_data);
                setInputAddress({
                  station_address_id: '', company_name: '', agent_or_handler: '', agent_type: 'E', address: '', email: [''], phone_number: ''
                });
                modalClose();
                setSelectedRowData(res.data.response_data)
              } else {
                toast.error(res.data.response_msg);
              }
            });

        } catch (error) {
          console.error('Error sending request:', error);
        }
      }

    }
  }
  // const handleChange = (e) => {
  //     setInputAddress({ ...inputAddress, [e.target.name]: e.target.value });
  // };

  // Email array start
  const handleEmailChange = (index, value) => {
    setInputAddress((prev) => {
      const updatedEmails = [...prev.email];
      updatedEmails[index] = value;
      return { ...prev, email: updatedEmails };
    });
  };

  const addEmailField = () => {
    setInputAddress((prev) => ({
      ...prev,
      email: [...prev.email, '']
    }));
  };

  const removeEmailField = (index) => {
    setInputAddress((prev) => ({
      ...prev,
      email: prev.email.filter((_, i) => i !== index)
    }));
  };
  // Email array end

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox' && name === 'regd') {
      setInputAddress({ ...inputAddress, [name]: checked ? '1' : '0' });
    } else {
      setInputAddress({ ...inputAddress, [name]: value });
    }
    // console.log(inputAddress);
  };

  const [selectedAddress, setSelectedAddress] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const modalEditShow = () => {
    setShowEdit(true);
    setInputAddress(selectedRowData)
  }
  const modalEditClose = () => setShowEdit(false);

  const handleEditChange = (e) => {
    setSelectedAddress(Prev => ({ ...Prev, [e.target.name]: e.target.value }));
  };

  const [isLoading, setIsLoading] = useState(true);
  const [gridData, setGridData] = useState({
    Active: [],
    Archived: []

  });

    useEffect(() => {
        if (isMounted.current) return;
        setIsLoading(false);
        setGridData({})
        isMounted.current = true;
    }, []);
    const [gridSelect, setGridSelect] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [showDetails, setShowDetails] = useState(false);

    const gridRef = useRef(null)

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {

        if (gridRef.current) { //  && !showDetails
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall();

            const source = {
                datatype: 'json',
                id: ``,
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'airline_name', type: 'string' },
                    { name: 'airline_prefix', type: 'string' },
                    { name: 'owner_code', type: 'string' },
                    { name: 'pickup_emails', type: 'string' },
                    { name: 'airline_master', type: 'string' },
                    { name: 'total_emails_count', type: 'string' },

                ],
                url: `${process.env.REACT_APP_RFS_URL}handler-airline-settings/list`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 10,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");

                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;

                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };

            const dataAdapter = new window.$.jqx.dataAdapter(source);
            // console.log('localdata', source.localdata)
            const columns = [
                // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
                { text: 'Airline Name', filtertype: 'input', datafield: 'airline_name', width: '30%', cellclassname: '', },
                {
                    text: 'Airline Prefix', filtertype: 'input', datafield: 'airline_prefix', width: '20%', cellclassname: 'frcl',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        console.log('270', rowdata)
                        // Check the value of the 'Status' field
                        if (rowdata.airline_master) {
                            // Return HTML with class 'inactive' for 'i' status
                            return '<div style="margin-top: 13px;">' + rowdata.airline_master.AWB_prefix + '</div>';
                        }
                    }
                },
                { text: 'Owner Code', filtertype: 'input', datafield: 'owner_code', width: '25%', cellclassname: 'frcl', },
                { text: 'Total Emails', filtertype: 'input', datafield: 'total_emails_count', width: '20%', cellclassname: '', },
            ];

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: true,
                sortable: true,
                altrows: false,
                enabletooltips: true,
                editable: false,
                selectionmode: '',
                pageable: true,
                pageSize: 10,
                pagesizeoptions: ['10', '20', '50', '100'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
            };

            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRef.current).on('rowclick', (event) => {
                // console.log('event', event);
                const args = event.args.row.bounddata;
                console.log('args', args);

                if (args?.agent_codes?.length) {
                    const agentCodeList = args.agent_codes.map(code => ({
                        id: code.id,
                        agent_code: code.agent_code
                    }));
                    setAgentCodes(agentCodeList);
                } else {
                    setAgentCodes([]);
                }
                // const sendRowId = gridData[activeTab];
                // console.log("🚀 ~ window.$ ~ sendRowId:", sendRowId)
                setSelectedRowData(args, { station_id: args.uid });

                setItems(args.pickup_emails)
                setShowDetails(true);
                const transformedData = {
                    ...args,
                    agent_type: args.regd,
                    // email: args.contact_email
                };
                setSelectedAddress(transformedData);
                setEmailShow(false);
            });
            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            // row selection by checkbox
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const selectedRowId = selectedRow.uid;
                    if (!gridSelect.some(row => row.uid === selectedRowId)) {
                        setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    }
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.address_id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.address_id !== unselectedRowId));
                }
            });
        }
    }, [gridData]);

  // Email section
  const emailArray = selectedRowData && selectedRowData.recovery_emails;
  // console.log("🚀 ~ StationDetails ~ emailArray:", emailArray)
  const [emailShow, setEmailShow] = useState(false);
  const inputEmailShow = () => setEmailShow(true);
  const [agentCodeShow, setAgentCodeShow] = useState(false);
  const addAgentCode = () => { setAgentCodeShow(true); console.log('101', selectedRowData) };
  const handleCloseAgentCode = () => { setAgentCodeShow(false) };
  const [inputData, setInputData] = useState("");
  const [items, setItems] = useState([]);
  const [agentCodes, setAgentCodes] = useState([]);
  const [editEmail, setEditEmail] = useState('');
  const [toggleButton, setToggleButton] = useState(false);
  const [modalConf, setModalConf] = useState(false);


  const [isEditingAgentCode, setIsEditingAgentCode] = useState(false);
  const [editingAgentCodeId, setEditingAgentCodeId] = useState(null);

  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [agentCodeToDelete, setAgentCodeToDelete] = useState(null);

    const AddEmail = () => {
        if (inputData == '') {
            // Alert('Please input Email');
            // console.log("Please input Email");
            document.getElementById('addEmail').classList.add('error');
            toast.error('Email address must not be blank');
            setEmailShow(true);
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!validateEmail(inputData)) {
            toast.error('Invalid email address');
            setEmailShow(true);
        }
        let payload = {};
        if (inputData && toggleButton) {
            payload = {
                id: selectedRowData.id,
                email: inputData,
                email_key: editEmail,
            }
        } else {
            payload = {
                id: selectedRowData.id,
                email: inputData
            }
        }

        CallApi({
            endPoint: 'handler-airline-settings/save-email',
            payload: payload,
            onSuccess: (data) => {
                // console.log('sendData', data);
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    setItems(data.data.response_data);
                    window.$(gridRef.current).jqxGrid('updatebounddata');
                } else {
                    toast.error(data.response_msg);
                }
                setInputData('');
                setEditEmail(null);
                setToggleButton(false);
                setEmailShow(false);
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const handleKeyPress = () => { document.getElementById('addEmail').classList.remove('error'); }
    const deleteConf = (idx) => { setModalConf(true); setEditEmail(idx); }
    const deleteEmail = (index) => {
        CallApi({
            endPoint: 'handler-airline-settings/remove-email',
            payload: { id: selectedRowData.id, email_key: index },
            onSuccess: (data) => {
                // console.log('sendData', data);
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    setItems(data.data.response_data);
                    setEditEmail('')
                    window.$(gridRef.current).jqxGrid('updatebounddata');
                } else {
                    toast.error(data.response_msg);
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }
    const EditEmail = (index) => {
        // const email_toedit = items.find((elem) => {
        //     return elem.id == index;
        // });
        setEmailShow(true);
        setToggleButton(true);
        setInputData(items[index]);
        setEditEmail(index);
    }
    // Email section End
    const handleInputChange = (e) => {
        const value = e.target.value.toUpperCase();
        if (/^[A-Z0-9]*$/.test(value)) {
            setFormData((prev) => ({ ...prev, agent_code: value }));
        }
    };

    return (
        <>
            {console.log('inputAddress', selectedRowData)}
            {modalConf &&
                <ConfModal
                    header={'Remove Email'}
                    subHeader={'Ar you sure you want to remove this email?'}
                    modalConf={() => deleteEmail(editEmail)}
                    closeModal={() => setModalConf(false)}
                    primaryBtn={'Yes'}
                    secondaryBtn={'No'}
                />
            }
            <div className='col-9 col-xxl-9 stting_right'>
                <div className='settingbg_right'>
                    <Row className=''>
                        <Col className='brd_rgt' lg="6">
                            <h4>Airline Settings</h4>
                            <p>Manage airline partners, contact details and message routing rules.</p>
                            <div className="station_grid">
                                {!isLoading && <div ref={gridRef} className='staion_grid' ></div>}
                            </div>
                        </Col>
                        <Col className='pt-4 px-4' lg="6">
                            {selectedRowData && (
                                <>
                                    <div className='handler_name'>
                                        {/* <div className='raedit'><Button variant="link" onClick={() => modalShow('edit')}><FontAwesomeIcon icon={faPencil} /> Edit</Button></div> */}
                                        <h2>{selectedRowData.airline_name}</h2>

                    <div className="handler_info">
                      <ul>
                        <h3>Airline Information</h3>
                        <li>
                          <span>Airline Prefix </span> :{" "}
                          <span>{selectedRowData.airline_master.AWB_prefix}</span>
                        </li>
                        <li>
                          <span>Owner Code</span> :{" "}
                          <span>{selectedRowData.owner_code}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="mt-3 ">
                    <h6>Process Time UCM In (SLA)</h6>
                  </div>
                  <div className="mt-3 ">
                    <div className="d-flex justify-content-between py-2">
                      <h6>Message Recipients</h6>
                      <div className="align-self-center">
                        <button
                          onClick={inputEmailShow}
                          className="add_adres"
                        >
                          + Add Email
                        </button>
                      </div>
                    </div>
                    <div className="addresses">
                      {emailShow && (
                        <>
                          <div className="add_email">
                            <input
                              name=""
                              value={inputData}
                              onKeyDown={handleKeyPress}
                              onChange={(e) => setInputData(e.target.value)}
                              id="addEmail"
                              type="text"
                              placeholder="Email type here"
                            />
                            {toggleButton ? (
                              <button onClick={AddEmail}>Edit</button>
                            ) : (
                              <button onClick={AddEmail}>
                                <FontAwesomeIcon icon={faPlus} /> Add
                              </button>
                            )}
                          </div>
                        </>
                      )}
                      <div className="showItem">
                        {console.log("555", items)}
                        {items &&
                          items.map((elem, index) => {
                            return (
                              <div className="eachItem" key={index}>
                                <h3><FontAwesomeIcon icon={faEnvelope} /> {elem}</h3>
                                {/* <button>Edit</button> */}
                                <div className="request_email">
                                  <button onClick={() => EditEmail(index)}><FontAwesomeIcon icon={faPencil} /></button>
                                  <button onClick={() => deleteConf(index)}><FontAwesomeIcon icon={faTrashCan} /></button>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>

                  <ImageUpload
                    attachable_type={"handler_airline_settings"}
                    attachable_id={selectedRowData.id}
                    attachments={selectedRowData.attachments}
                  />
                </>
              )}
            </Col>
          </Row>
          <Modal show={show} onHide={modalClose} centered className="addfrom">
            <Modal.Header closeButton onClick={modalClose}>
              <Modal.Title>
                {isEdit === "edit" ? "Edit" : "Add"} Address -{" "}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group className="mb-2">
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  type="text"
                  onChange={handleChange}
                  name="company_name"
                  placeholder="Company Name"
                  value={inputAddress.company_name}
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Agent or Handler</Form.Label>
                <Form.Check
                  inline
                  label="Agent"
                  name="agent_or_handler"
                  type="radio"
                  id="export"
                  value="A"
                  checked={inputAddress.agent_or_handler === "A"}
                  onChange={handleChange}
                />

                <Form.Check
                  inline
                  label="Handler"
                  value="H"
                  name="agent_or_handler"
                  type="radio"
                  id="import"
                  checked={inputAddress.agent_or_handler === "H"}
                  onChange={handleChange}
                />
              </Form.Group>
              {inputAddress.agent_or_handler == "A" && (
                <>
                  <Form.Group className="mb-2">
                    <Form.Check
                      inline
                      label="External"
                      name="agent_type"
                      type="radio"
                      id="external"
                      value="E"
                      checked={inputAddress.agent_type === "E"}
                      onChange={handleChange}
                    />

                    <Form.Check
                      inline
                      label="Internal"
                      value="I"
                      name="agent_type"
                      type="radio"
                      id="internal"
                      checked={inputAddress.agent_type === "I"}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </>
              )}
              <Form.Group className="mb-2">
                <Form.Label>Address </Form.Label>
                <Form.Control
                  type="text"
                  onChange={handleChange}
                  name="address"
                  placeholder="Address"
                  value={inputAddress.address}
                />
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>
                  Email ID{" "}
                  <Link to="#" className="raad_adrss" onClick={addEmailField}>
                    + Add Email
                  </Link>
                </Form.Label>
                {/* <Form.Control type="text" onChange={handleChange} name='email' placeholder="E-mail" /> */}
                {inputAddress?.email?.map((email, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center position-relative mb-2"
                  >
                    <Form.Control
                      type="text"
                      placeholder="E-mail"
                      value={email}
                      onChange={(e) =>
                        handleEmailChange(index, e.target.value)
                      }
                      className=""
                    />
                    {inputAddress.email.length > 1 && (
                      <Link
                        to="#"
                        onClick={() => removeEmailField(index)}
                        className="email_del"
                      >
                        {" "}
                        <FontAwesomeIcon icon={faCircleXmark} />{" "}
                      </Link>
                    )}
                  </div>
                ))}
              </Form.Group>
              <Form.Group className="mb-2">
                <Form.Label>Telephone No</Form.Label>
                <Form.Control
                  type="number"
                  onChange={handleChange}
                  name="phone_number"
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 50);
                  }}
                  placeholder="Number"
                  value={inputAddress.phone_number}
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" onClick={addAddress}>
                {isEdit === "edit" ? "Update" : "Add"} Address
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default AirlineSettings;